import React from "react";
import { useTranslation } from "../../../contexts/TranslationProvider";

const ContractCardActionsModal = ({ onDelete, onView, onDesactivate, onEdit}: {
  onDelete: () => void;
  onView: () => void;
  onDesactivate?: () => void;
  onEdit?: () => void;
}) => {
  const { t, language } = useTranslation();
  const actionCaller = (e, action)=>{
    e.stopPropagation();
    action();
  }
  return (
    <div className="contract-card-actions-modal" style={{marginRight:language=="ar"&&"-30px"}}>
      <ul>
        <li onClick={(e)=>actionCaller(e, onView)}>{t("pages.ressources.actions.view")}</li>
        <li onClick={(e)=>{actionCaller(e, onDelete)}}>{t("pages.ressources.actions.delete")}</li>
        {
          onDesactivate && <li onClick={(e)=>{actionCaller(e, onDesactivate);e.preventDefault(); e.stopPropagation()}}>{t("pages.ressources.actions.desactivate")}</li>
        }
        {
          onEdit && <li onClick={(e)=>actionCaller(e, onEdit)}>{t("pages.ressources.actions.edit")}</li>
        }
      </ul>
    </div>
  );
};

export default ContractCardActionsModal;
